import React, { Component } from 'react';
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { Field, reduxForm } from 'redux-form';
import RaisedButton from 'material-ui/RaisedButton';

import { savePatientSkillsAcquisitionCollectedData, getPatientSkillAcqPreviousTrialist, deletePatientSkillAcqPreviousTrial } from './actions/targetsAction'; 
import { CancelButton } from '../../../../../../../../components/buttons';
import SmallLoader from '../../../../../../../../img/small-loader.gif';
import {  renderCheckBox } from '../../../../../../../../components/reduxFields';


class DTTModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: true,
            patientId: props.patientId ? parseInt(props.patientId) : null,
            promptCodeListData: this.props.promptCodeListData && this.props.promptCodeListData.data ? this.props.promptCodeListData.data.filter((obj) => obj.dtt === true) : [],
        }
    }

    componentWillMount = () => {
        this.props.getPatientSkillAcqPreviousTrialist(this.state.patientId, this.props.uuid, this.props.targetObj.skillsAcquisitionTargetId)
    }

    componentWillReceiveProps(nextProps) {
        let self = this;
        document.onkeydown = function (evt) {
            evt = evt || window.event;
            if (evt.keyCode === 27) {
                self.handleClose();
            }
        };
    }

    handleClose = () => {
        if (this.state.open) {
            this.setState({ open: false });
            this.props.closeDialog();
        }
    };

    deletePreviousTrial = () => {
        if(this.props.patientSkillAcqActiveTargetList.length > 0) {
            let collectedDataId = this.props.patientSkillAcqActiveTargetList[0].id
            this.props.deletePatientSkillAcqPreviousTrial(collectedDataId,this.state.patientId, this.props.uuid, this.props.targetObj.skillsAcquisitionTargetId)
        }
    }

    renderLoading = () => {
        return (
            <div>
                {this.props.loading ? (
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

   onChangeHandler = obj => {
        let authData = {
            "id": 0,
            "skillsAcquisitionProgramId": this.props.targetObj.skillsAcquisitionProgramId,
            "skillsAcquisitionTargetId": this.props.targetObj.skillsAcquisitionTargetId,
            "patientId": this.props.patientId,
            "sessionId": this.props.uuid,
            "sessionDate": this.props.creadteDate,
            "patientPromptCodeId": obj.promptCodeId,
            "score": obj.scoreAsIndependent === true ? 1 : 0,
            "patientCollectedDataTaskAnalysisModel": [],
            "statusId": this.props.statusId
        } 
        this.props.savePatientSkillsAcquisitionCollectedData(authData, this.state.patientId, this.props.uuid, this.props.targetObj.skillsAcquisitionTargetId,'DTT');
    }

    renderPreviousTrial = (prevData) => {
        return (
            prevData.map((Obj, index) => {
                return <span key={index}>&nbsp;{Obj.previousTrail}</span>
            })
        )
    }

    render() {
        let prevData = [],
        todayCompletedTrails = 0,
        desiredDailyTrials = 0;

        if(this.props.patientSkillAcqActiveTargetList !== false) {
            prevData = this.props.patientSkillAcqActiveTargetList;
        }
        if(this.props.patientSkillsAcqDailyTrails && this.props.patientSkillsAcqDailyTrails.length > 0) {            
            todayCompletedTrails = this.props.patientSkillsAcqDailyTrails[0].todayCompletedTrails;
            desiredDailyTrials = this.props.patientSkillsAcqDailyTrails[0].desiredDailyTrials;
        }
        
        const actions = [
            <RaisedButton
            style={{ float: 'right' }}
            label="Delete Previous Trial"
            disabled={prevData.length > 0 ? false : true}
            primary={true}
            onTouchTap={() => this.deletePreviousTrial()} />,
        <CancelButton className="mr-15" onTouchTap={this.handleClose} btnlabel="Done"/>];       
        return (
            <Dialog
                className="custom_modal"
                title={this.props.targetObj.targetName}
                modal={false}
                open={this.state.open}
                actions={actions}
                autoScrollBodyContent={true}
            >
                {this.renderLoading()}
                <div className="row mt-20">
                    <div className="col-sm-12">
                        <form className="readmin-form custom_form">
                            <div className="row mt-10">
                                <div className='col-sm-12'>
                                   <span><b>Program Name :</b>&nbsp;{this.props.targetObj.programName}</span>
                                </div>
                            </div>
                            <div className="row mt-10">
                                <div className='col-sm-12'>
                                  <span><b>Target Name :</b>&nbsp;{this.props.targetObj.targetName}</span>
                                </div>
                            </div>
                            <div className="row mt-10">
                                <div className='col-sm-12'>
                                   <span><b>SD :</b>&nbsp;{this.props.targetObj.sd}</span>
                                </div>
                            </div>
                            <div className="row mt-10">
                                <div className='col-sm-12 require'>
                                   <span><b>Notes :</b></span>
                                   {/* <span style={{ display: 'block', wordWrap: 'break-word'}}>{this.props.targetObj.programInstructions}</span> */}
                                   <span style={{ display: 'block', wordWrap: 'break-word'}}>{this.props.targetObj.targetInstructions || this.props.targetObj.programInstructions}</span>
                                </div>
                            </div>
                            {desiredDailyTrials > 0 &&
                                <div className="row mt-10">
                                    <div className='col-sm-12 mt-10'>
                                        <span><b>Trials Done :</b> {todayCompletedTrails} out of {desiredDailyTrials}</span>                                       
                                    </div>
                                </div>    
                            }
                            {prevData.length > 0 &&
                                <div className="row">
                                    {/* <div className='col-sm-12 mt-10'>                                    
                                        <span><b>Prompt Delay :</b></span>
                                        {prevData.map((Obj, index) => {
                                        return <span key={index}>&nbsp;{Obj.promptDelay}</span>
                                        })}                                        
                                    </div> */}
                                    <div className='col-sm-12 mt-10'>
                                        <span><b>Previous Trial :</b></span>
                                        {this.renderPreviousTrial(prevData)}
                                    </div>
                                </div>                                
                            }                            
                            <div className="row mt-10" style={{ marginLeft: '0px' }}> 
                                {
                                    this.state.promptCodeListData.map((obj, index) => {
                                        return (
                                            <div className="col-sm-6 mt-10" key={index}>
                                                <Field 
                                                className="mt20 mb0"
                                                onChange={() => this.onChangeHandler(obj)}
                                                name={obj.promptCodeName}
                                                label={obj.promptCodeName}
                                                component={renderCheckBox}
                                                value={true}
                                                />
                                            </div>
                                        )
                                    })
                                }
                            </div>                           
                        </form>
                    </div>
                </div>
            </Dialog>
        )
    }
}

DTTModal = reduxForm({
    form: 'DTTModalForm',
    enableReinitialize: true,
})(DTTModal);


function mapStateToProps(state, ownProps) {
    return {
        loading: state.patientSkillAcqActiveTarget.loadingCollectedData || state.patientSkillAcqActiveTarget.loadingPreviousTrial,
        patientSkillAcqActiveTargetList: state.patientSkillAcqActiveTarget.patientSkillAcqPreviousTrialList !== null && state.patientSkillAcqActiveTarget.patientSkillAcqPreviousTrialList.data.PatientSkillsAcqPreviousTrail,
        patientSkillsAcqDailyTrails: state.patientSkillAcqActiveTarget.patientSkillAcqPreviousTrialList !== null && state.patientSkillAcqActiveTarget.patientSkillAcqPreviousTrialList.data.PatientSkillsAcqDailyTrails,
    }
}

export default connect(mapStateToProps, {savePatientSkillsAcquisitionCollectedData, getPatientSkillAcqPreviousTrialist, deletePatientSkillAcqPreviousTrial})(DTTModal);


// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/SkillAquisition/components/targets/DttModal.js